import { render, staticRenderFns } from "./TheNewsletter.vue?vue&type=template&id=16c23fcb&"
import script from "./TheNewsletter.vue?vue&type=script&lang=js&"
export * from "./TheNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./TheNewsletter.vue?vue&type=style&index=0&id=16c23fcb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports